import axios from 'axios';

class Apis {

  constructor() {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.baseUri = `http://${window.location.hostname}:8540/api/`;
    } else {
      this.baseUri = 'https://single-server.lipi.live/api/';
    }
  }

  async _callApi(path, data) {
    let uri = this.baseUri + path;
    let results;
    try {
      axios.defaults.baseURL = '';
      axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      results = await axios.post(uri, data)
      results = results.data;
    } catch (ex) {
      results = {
        hasError: true,
        error: {
          code: 'NETWORK_ERROR',
          message: "Unable to connect to the server. Please make sure you are connected to the internet."
        }
      }
    }
    return results;
  }

  async _callApiWithMinimumDelay(path, data) {
    const minimumDelay = 1000;
    let atThatTime = Date.now();
    let res = await this._callApi(path, data);
    let now = Date.now();
    if (now - atThatTime < minimumDelay) {
      await new Promise(accept => {
        window.setTimeout(accept, (minimumDelay - (now - atThatTime)));
      })
    }
    return res;
  }

  async callShopGetOutletDetailsApi(data) {
    return await this._callApiWithMinimumDelay('shop-get-outlet-details', data);
  }

  async callShopLocateNearbyOutletsApi(data) {
    return await this._callApiWithMinimumDelay('shop-locate-nearby-outlets', data);
  }

  async callGetOutletCategoryListApi(data) {
    return await this._callApiWithMinimumDelay('get-outlet-category-list', data);
  }

  async callLiteGetReceiptApi(data) {
    return await this._callApiWithMinimumDelay('lite-get-receipt', data);
  }

}

export default (new Apis());
